export function getPayoutSummaryV3(send) {
  return (payoutId, ...args) =>
    send(
      {
        path: '/v3/payouts/{payoutId}',
        pathParameters: { payoutId },
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
